import { Icon, IconButton } from '@atom/mui';
import { type IconComponent } from '@atom/mui/icons';

interface PassedProps {
  style?: object;
  tooltip?: string;
  disabled?: boolean;
  onClick?: () => void;
  color: string;
  icon: IconComponent;
  tooltipPosition?: string;
}

type Props = PassedProps;

const FontIconButton = ({
  style = {},
  tooltip = '',
  onClick = () => {},
  disabled,
  color,
  icon,
  tooltipPosition = 'bottom-center',
}: Props) => {
  return (
    <IconButton
      style={style}
      tooltip={tooltip}
      onClick={onClick}
      disabled={disabled}
      // @ts-ignore
      tooltipPosition={tooltipPosition}
    >
      <Icon color={color} icon={icon} />
    </IconButton>
  );
};

export default FontIconButton;
